"use client";

import { createLazyComponent } from "@/app/ui/molecular/createLazyComponent";

const LogoCarousel = createLazyComponent(
  () => import("@/app/ui/molecular/LogoCarousel"),
  {
    skeleton: {
      type: "horizontal-scroll",
      itemWidth: 288,
      itemHeight: 280,
      count: 4,
    },
  }
);

export default LogoCarousel;
